class CartEvents {
  static eventName = 'cart:updated';

  static async updateCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.renderCart(cart);
      this.updateGlobalCartCount(cart.item_count);
      this.openCart(); 
      
      // Disparar evento con los datos del carrito
      window.dispatchEvent(new CustomEvent(this.eventName, {
        detail: { cart }
      }));
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  static renderCart(cart) {
    const cartContainer = document.querySelector('[data-cart-items]');
    const cartFooter = document.querySelector('.js-cart-footer');
    
    if (!cartContainer || !cartFooter) {
      console.error('No se encontraron los contenedores del carrito');
      return;
    }

    if (cart.item_count === 0) {
      cartContainer.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      cartFooter.innerHTML = '';
      return;
    }

    // Renderizar items usando el formateador global
    cartContainer.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-variant-id="${item.variant_id}">
        <img src="${item.image}" alt="${item.title}" width="80" height="80">
        <div class="cart-item-details">
          <h3>${item.product_title}</h3>
          ${item.variant_title ? `<p class="variant-title">${item.variant_title}</p>` : ''}
          <div class="cart-item-price" data-price data-original-price="${item.final_line_price}">
            ${window.formatMoney(item.final_line_price)}
          </div>
          <div class="cart-item-quantity">
            <button class="quantity-btn js-qty-decrease">-</button>
            <input type="number" value="${item.quantity}" min="1" class="js-qty-input" readonly>
            <button class="quantity-btn js-qty-increase">+</button>
          </div>
          <button class="remove-item js-remove-item">Remove</button>
        </div>
        
      </div>
    `).join('');

    // Renderizar footer con el formateador global
    cartFooter.innerHTML = `
      <div class="cart-total">
        <span>Total:</span>
        <strong data-price data-original-price="${cart.total_price}">
          ${window.formatMoney(cart.total_price)}
        </strong>
      </div>
      <p class="checkout-shipping">Shipping is calculated at checkout.</p>
      <a href="/checkout" class="btn btn-add-to-cart">Check out</a>
      <a href="/cart" class="btn btn-view-cart">View Cart</a>
    `;

    this.attachCartHandlers();
  }

  static updateGlobalCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
    });
  }

  static attachCartHandlers() {
    // Manejadores de cantidad
    document.querySelectorAll('.js-qty-decrease, .js-qty-increase').forEach(button => {
      button.addEventListener('click', (e) => {
        const item = e.target.closest('.cart-item');
        const input = item.querySelector('.js-qty-input');
        const currentQty = parseInt(input.value);
        const isDecrease = e.target.classList.contains('js-qty-decrease');
        
        const newQty = isDecrease ? Math.max(0, currentQty - 1) : currentQty + 1;
        if (newQty === 0) {
          this.removeItem(item.dataset.variantId);
        } else {
          this.updateItemQuantity(item.dataset.variantId, newQty);
        }
      });
    });

    // Manejador de eliminación
    document.querySelectorAll('.js-remove-item').forEach(button => {
      button.addEventListener('click', (e) => {
        const item = e.target.closest('.cart-item');
        this.removeItem(item.dataset.variantId);
      });
    });
  }

  static async updateItemQuantity(variantId, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      await this.updateCart();
    } catch (error) {
      console.error('Error updating item:', error);
    }
  }

  static async removeItem(variantId) {
    await this.updateItemQuantity(variantId, 0);
  }

  static openCart() {
    const sideCart = document.getElementById('side-cart');
    if (sideCart) {
      sideCart.classList.add('open');
    }
  }

  static closeCart() {
    const sideCart = document.getElementById('side-cart');
    if (sideCart) {
      sideCart.classList.remove('open');
    }
  }

  static init() {
    this.updateCart();
    
    // Actualizar cuando se añaden productos desde cualquier parte
    window.addEventListener('product:added', () => this.updateCart());
  }
}

class PageCart {
  static init() {
    const pageCart = document.querySelector('[data-page-cart]');
    if (!pageCart) return;

    this.bindEvents();
    
    // Escuchar actualizaciones globales del carrito
    window.addEventListener('cart:updated', ({ detail }) => {
      this.updatePageCart(detail.cart);
    });
  }

  static bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.matches('.js-qty-decrease, .js-qty-increase')) {
        const item = e.target.closest('[data-variant-id]'); // Cambiado para usar el data-attribute
        const input = e.target.closest('.quantity-selector').querySelector('.js-qty-input');
        const currentQty = parseInt(input.value);
        const isDecrease = e.target.classList.contains('js-qty-decrease');
        
        const newQty = isDecrease ? Math.max(0, currentQty - 1) : currentQty + 1;
        if (newQty === 0) {
          CartEvents.removeItem(item.dataset.variantId);
        } else {
          CartEvents.updateItemQuantity(item.dataset.variantId, newQty);
        }
      }

      if (e.target.matches('.js-remove-item')) {
        const item = e.target.closest('[data-variant-id]');
        CartEvents.removeItem(item.dataset.variantId);
      }
    });
  }

  static updatePageCart(cart) {
    const container = document.querySelector('[data-page-cart-items]');
    const totalElement = document.querySelector('[data-cart-total]');
    if (!container) return;

    if (cart.item_count === 0) {
      document.querySelector('[data-page-cart]').innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      return;
    }

    // Actualizar cantidades y precios sin reemplazar toda la tabla
    cart.items.forEach(item => {
      const row = container.querySelector(`[data-variant-id="${item.variant_id}"]`);
      if (row) {
        row.querySelector('[data-price]').innerHTML = window.formatMoney(item.price);
        row.querySelector('.js-qty-input').value = item.quantity;
        row.querySelector('[data-line-price]').innerHTML = window.formatMoney(item.line_price);
      }
    });

    if (totalElement) {
      totalElement.innerHTML = window.formatMoney(cart.total_price);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  CartEvents.init();
  PageCart.init();
});